import React, { useState } from 'react';
import downArrow from '../image/down-arrow.svg';

const faqData = [
  {
    question: "C'est quoi une carte virtuelle ?",
    answer: "Une carte virtuelle est une carte qui n'existe pas physiquement. Elle est créée sur le site et peut être utilisée pour des transactions en ligne."
  },
  {
    question: "Que puis-je payer avec les cartes virtuelles Adabo Cash ?",
    answer: "Vous pouvez utiliser les cartes virtuelles Adabo Cash pour payer les publicités sur les réseaux sociaux (ex: Facebook, Instagram, etc.). Vous pouvez également utiliser les cartes virtuelles Adabo Cash pour payer sur les sites e-commerce et d'autres services en ligne."
  },
  {
    question: "Comment puis-je créer une carte virtuelle ?",
    answer: "Pour créer une carte virtuelle, vous devez vous rendre sur le menu 'Cartes' puis cliquer sur 'Créer une carte'."
  },
  {
    question: "Combien de cartes virtuelles puis-je créer ?",
    answer: "Vous pouvez créer autant de cartes virtuelles que vous le souhaitez."
  },
  {
    question: "Quel est le prix d'une carte virtuelle ?",
    answer: "Le prix d'une carte virtuelle est de $ 4 par carte émise."
  }
]

const faqData2 = [
  {
    question: "Comment puis-je échanger mes MGA en USDT ?",
    answer: "Pour échanger vos MGA en USDT, vous devez vous rendre sur le menu 'Echange' puis cliquer sur 'Echanger'."
  },
  {
    question: "Quel est le cours d'échange USDT ?",
    answer: "Pour voir le cours d'échange USDT, vous devez vous rendre sur le menu 'Echange'."
  },
  {
    question: "Combien de temps dure un échange USDT ?",
    answer: "L'échange se fait instantanément."
  },
  {
    question: "Combien de temps dure le retrait USDT ?",
    answer: "Le retrait se fait en environ 3 minutes."
  },
  {
    question: "Quel est le montant minimum pour le retrait USDT ?",
    answer: "Le montant minimum pour le retrait USDT est de 10 USDT."
  },
  {
    question: "Quel est le montant maximum pour le retrait USDT ?",
    answer: "Le montant maximum pour le retrait USDT est de 10000 USDT."
  }
  
]

const ContactPage = () => {

  const [activeIndex, setActiveIndex] = useState(null);
  const [activeIndex2, setActiveIndex2] = useState(null);

  const toggleAnswer = (index) => {
  setActiveIndex(activeIndex === index ? null : index);
}

const toggleAnswer2 = (index2) => {
  setActiveIndex2(activeIndex2 === index2 ? null : index2);
}

  return (
    <section className="contact-section">
      <div className="dashboard-header">
        <h2>Contact</h2>
      </div>
      <div className="placeholder contact-placeholder-container">
        <ul className="contact-list">
          <li className="contact-item">
            <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/63/Facebook_Messenger_logo_2025.svg/1920px-Facebook_Messenger_logo_2025.svg.png" alt="Facebook Messenger" className="contact-icon" />
            <a href="https://m.me/adabocash" target="_blank" rel="noopener noreferrer" className="contact-link-messenger">
              Facebook Messenger
            </a>
          </li>
          <li className="contact-item">
            <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/8/82/Telegram_logo.svg/1024px-Telegram_logo.svg.png" alt="Telegram" className="contact-icon" />
            <a href="https://t.me/adabocash_bot" target="_blank" rel="noopener noreferrer" className="contact-link-telegram">
              Telegram
            </a>
          </li>
          <li className="contact-item">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="contact-webchat-icon">
              <rect x="2" y="4" width="20" height="16" rx="4" fill="#3b82c4"/>
              <path d="M6 10h12M6 14h8" stroke="#fff" strokeWidth="2" strokeLinecap="round"/>
            </svg>
            <a href="https://app.botgascar.com/webchat/?p=1450251&id=tIpqCOiezPF6IxsWjRC" target="_blank" rel="noopener noreferrer" className="contact-link-webchat">
              Webchat
            </a>
          </li>
        </ul>
      </div>

      <div>
        <h2 className="faq-title">FAQ sur les cartes virtuelles</h2>
        <div className="faq-container">
          {faqData.map((item, index) => (
            <div key={index} className="faq-item">
              <button
                type="button"
                className="faq-question"
                aria-expanded={activeIndex === index}
                aria-controls={`virtual-card-answer-${index}`}
                onClick={() => toggleAnswer(index)}
              >
                <span>{item.question}</span>
                <span aria-hidden="true">
                  <img
                    src={downArrow}
                    alt=""
                    className={`faq-arrow${activeIndex === index ? ' open' : ''}`}
                  />
                </span>
              </button>
              <div id={`virtual-card-answer-${index}`} className="faq-answer">
                {activeIndex === index && item.answer}
              </div>
            </div>
          ))}
        </div>
        <h2 className="faq-title">FAQ sur l'échange USDT</h2>
        <div className="faq-container">
          {faqData2.map((item2, index2) => (
            <div key={index2} className="faq-item">
              <button
                type="button"
                className="faq-question"
                aria-expanded={activeIndex2 === index2}
                aria-controls={`usdt-answer-${index2}`}
                onClick={() => toggleAnswer2(index2)}
              >
                <span>{item2.question}</span>
                <span aria-hidden="true">
                  <img
                    src={downArrow}
                    alt=""
                    className={`faq-arrow${activeIndex2 === index2 ? ' open' : ''}`}
                  />
                </span>
              </button>
              <div id={`usdt-answer-${index2}`} className="faq-answer">
                {activeIndex2 === index2 && item2.answer}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
    
  );
};

export default ContactPage; 